import UserActions from "../Types";
import responseHandler from "../../utils/responseHandler";
import Instance from "../../utils/apiCert";
import Storage from "../../utils/storage";

// GET PAYMENT DETAILS FOR CERTIFICATION
export const getCertPaymentDetailsStart = () => ({
    type: UserActions.GET_CERT_PAYMENT_DETAILS_START
})

export const getCertPaymentDetailsSuccess = payload => ({
    type: UserActions.GET_CERT_PAYMENT_DETAILS_SUCCESS,
    payload
})

export const getCertPaymentDetailsFailure = payload => ({
    type: UserActions.GET_CERT_PAYMENT_DETAILS_FAILURE,
    payload
})

// GET PAYMENT DETAILS FOR TEST CARD
export const getTestCardPaymentDetailsStart = () => ({
    type: UserActions.GET_TESTCARD_PAYMENT_DETAILS_START
})

export const getTestCardPaymentDetailsSuccess = payload => ({
    type: UserActions.GET_TESTCARD_PAYMENT_DETAILS_SUCCESS,
    payload
})

export const getTestCardPaymentDetailsFailure = payload => ({
    type: UserActions.GET_TESTCARD_PAYMENT_DETAILS_FAILURE,
    payload
})

// PAY FOR TEST CARD
export const verifyPaymentStart = () => ({
    type: UserActions.VERIFY_PAYMENT_START
})

export const verifyPaymentSuccess = payload => ({
    type: UserActions.VERIFY_PAYMENT_SUCCESS,
    payload
})

export const verifyPaymentFailure = payload => ({
    type: UserActions.VERIFY_PAYMENT_FAILURE,
    payload
})

export const getCertPaymentDetails = (payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    dispatch(getCertPaymentDetailsStart());
    API.post("transaction/details", payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(getCertPaymentDetailsSuccess(data.data));
        } else {
            dispatch(getCertPaymentDetailsFailure(data));
        }
    })
}

export const getTestCardPaymentDetails = (payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    dispatch(getTestCardPaymentDetailsStart());
    API.post("transaction/details", payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(getTestCardPaymentDetailsSuccess(data.data));
        } else {
            dispatch(getTestCardPaymentDetailsFailure(data));
        }
    })
}

export const verifyPayment = (payload) => async dispatch => {
    const API = Instance.customAxiosInstance(Storage.get("user-access-token"))

    dispatch(verifyPaymentStart());
    API.post("transaction/verify", payload).then((response) => {
        const {
            data,
            ok
        } = response;
        responseHandler(response);
        if (ok) {
            dispatch(verifyPaymentSuccess(data.success));
        } else {
            dispatch(verifyPaymentFailure(data));
        }
    })
}